import axios from 'axios'
import {jsonHeader} from '@/helpers/axiosHeaders'
import qs from "qs";
const state = {
    itemsTop: [],
    itemsAction: [],
	prevRoute: false,
}

// getters
const getters = {
    ActionPageCouponUrl: state => data =>{
        let currentIndex;
        for (let index in state.itemsAction['coupons']) {
            if (state.itemsAction['coupons'][index].code == data.action) {
                currentIndex = index;
                break;
            }
        }
        return '/moderator/coupons/'+state.itemsAction['coupons'][currentIndex].id+'/';
    },
    ActionPageCouponTitle: state => data => {
        let currentIndex,
        title = '';
        for (let index in state.itemsAction['coupons']) {
            if (state.itemsAction['coupons'][index].code == data.action) {
                currentIndex = index;
                break;
            }
        }

        if (typeof (state.itemsAction['coupons']) !== 'undefined') {
            title = state.itemsAction['coupons'][currentIndex]['name']
        }
        if(title!=''){
                title = title+' акции';
        }
        return title;
    },
    RepaymentPage: state => data => {
        for (let index in state.itemsAction['repayment']) {
            if (state.itemsAction['repayment'][index].code == data.currentStatus) {
                return state.itemsAction['repayment'][index];
            }
        }
    }
}

const actions = {
    getMenu(context, data) {
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_PATH+'/'+data.type+'/menus/',{
                headers: {'Content-Type': 'application/json;charset=utf-8','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                params: {
                    type: 'top',
                },
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
                withCredentials: true,

            }).then(response => {
                if(typeof response.data === 'object' && +response.data.error === 0) {

                } else {
                    if( +response.data.error===401){
                        context.dispatch('auth/logout',{},{root:true})
                    }
                }
                resolve(response.data.result);
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                resolve();
            });
        });
    },
    getActionMenu(context, data) {
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_PATH+'/'+data.type+'/menus/',{
                headers: {'Content-Type': 'application/json;charset=utf-8','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                params: {
                    type: 'action',
                },
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
                withCredentials: true,

            }).then(response => {
                if(typeof response.data === 'object' && +response.data.error === 0) {
                    context.commit('setActionMenu', response.data.result);
                    resolve();
                } else {
                    if( +response.data.error===401){
                        context.dispatch('auth/logout',{},{root:true})
                    }
                }
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
}

const mutations = {
    setMenu(state, data) {
        if(typeof data === 'object' && data.top !== undefined) {
            state.itemsTop = data.top;
        }
    },
    setActionMenu(state, data){
        if(typeof data === 'object' && data.items !== undefined) {
            state.itemsAction = data.items;
        }
    },
	setPrevRoute(state, data) {
        state.prevRoute = data;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
